import { Info } from "lucide-react";
import { HELP, STAGES } from "../../lib/bookTabs";
import { TabsList, TabsTrigger } from "../ui/tabs";

export function GuidedTabs({ tabs, tab }) {
  const have = new Set(tabs.map(([k]) => k));
  const label = Object.fromEntries(tabs);
  const groups = STAGES.map(([name, keys]) => [name, keys.filter((k) => have.has(k))]).filter(([, k]) => k.length);
  return (
    <div className="mb-8 space-y-3">
      <TabsList className="bg-transparent p-0 h-auto flex flex-wrap items-start justify-start gap-x-5 gap-y-3" data-testid="guided-tabs">
        {groups.map(([name, keys], gi) => (
          <div key={name} className="flex flex-col gap-1.5" data-testid={`tab-stage-${gi}`}>
            <span className="text-[10px] uppercase tracking-[0.18em] text-slate-500 px-1"><span className="font-mono text-amber-400/80 mr-1">{gi + 1}</span>{name}</span>
            <div className="flex flex-wrap gap-1 bg-slate-900/80 border border-slate-800 rounded-lg p-1">
              {keys.map((k) => <TabsTrigger key={k} value={k} title={HELP[k]} data-testid={`tab-${k}`} className="data-[state=active]:bg-amber-600 data-[state=active]:text-white text-xs sm:text-sm">{label[k]}</TabsTrigger>)}
            </div>
          </div>
        ))}
      </TabsList>
      {HELP[tab] && <p className="flex items-start gap-2 text-xs text-slate-300 bg-amber-500/5 border border-amber-500/20 rounded-lg px-3 py-2" data-testid="tab-help"><Info size={14} className="text-amber-300 shrink-0 mt-0.5" /><span><b className="text-amber-200">{label[tab]}:</b> {HELP[tab]}</span></p>}
    </div>
  );
}
